export default "/assets/site/images/bodai_istvan.png?844eee3bc85b4dedcd5149e2b26cc401";